import { withDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiPopper']} */
const overwrite = {}

export const MuiPopper = withDisablePortal(overwrite)
